export const SITE_COPY = {
  nav: {
    about: "About",
    work: "Work",
    experience: "Experience",
    writing: "Writing",
    skills: "Skills",
    contact: "Contact",
    resume: "Résumé",
    menuOpen: "Menu",
    menuClose: "Close",
    home: "Home",
  },
  hero: {
    resumeCta: "View résumé",
    emailCta: "Get in touch",
    aboutCta: "About me",
  },
  home: {
    exploreTitle: "Explore",
    exploreLead: "Pick a path. Each page covers one part of the story.",
    paths: {
      about: "Who I am and the stack I ship with.",
      experience: "Roles, ownership and production impact.",
      work: "Products and tools I have built end to end.",
    },
  },
  sections: {
    about: "About",
    aboutLead: "How I work and what I care about when shipping software.",
    work: "Work",
    workLead:
      "Products and tools I have shipped end to end, from interface to infrastructure.",
    experience: "Experience",
    experienceLead:
      "Roles where I owned features, platforms and the messy path to production.",
    writing: "Writing",
    writingLead:
      "Notes on shipping reliable systems and the tools around them.",
    skills: "Capabilities",
    skillsLead:
      "The stack I use to ship interfaces, APIs and the infra around them.",
    education: "Education",
    contact: "Contact",
  },
  work: {
    live: "Live site",
    github: "Source",
    preview: "Product preview",
  },
  writing: {
    read: "Read",
  },
  experience: {
    showImpact: "Show impact",
    hideImpact: "Hide impact",
  },
  contact: {
    lead: "Open to full-stack roles where I can own product, platform and the path to production.",
    emailLabel: "Email",
  },
};
